import { EventName } from '@lit/react';
import { BlocksChipGroup } from 'blocks-nextjs/blocks-web-components/components/chip-group/chip-group';
import { BlocksChipRemoveEvent, BlocksChipSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatChipGroup = createComponent({
  react: React,
  tagName: 'cat-chip-group',
  elementClass: BlocksChipGroup,
  events: {
    onBlChipRemove: 'bl-chip-remove' as EventName<BlocksChipRemoveEvent>,
    onBlChipSelect: 'bl-chip-select' as EventName<BlocksChipSelectEvent>
  }
});
